import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import SessionList from '../components/SessionList.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/login',
    name: 'login',
    component: () => import('../components/LoginPage.vue'),
    meta: { title: 'Tracium -Sign In', requiresAuth: false, isLoginPage: true }
  },
  {
    path: '/',
    redirect: '/sessions'
  },
  {
    path: '/sessions',
    name: 'sessions',
    component: SessionList,
    meta: { title: 'Tracium -Sessions', requiresAuth: true }
  },
  {
    path: '/replay/:id',
    name: 'session-replay',
    component: () => import('../components/SessionReplay.vue'),
    meta: { title: 'Tracium -Replay', requiresAuth: true }
  },
  {
    path: '/analytics',
    name: 'analytics',
    component: () => import('../components/AnalyticsPage.vue'),
    meta: { title: 'Tracium -Analytics', requiresAuth: true }
  },
  {
    path: '/assistant',
    name: 'assistant',
    component: () => import('../components/AssistantPage.vue'),
    meta: { title: 'Tracium - Assistant', requiresAuth: true }
  },
  // Backward-compatible redirects from the previous /ask and /search pages.
  // The old standalone pages are removed in Phase F; the unified /assistant
  // covers both surfaces. Query params (?session=… / ?project=…) carry over
  // so a bookmarked URL still routes the user to the same in-scope context.
  { path: '/ask',    redirect: (to: any) => ({ name: 'assistant', query: to.query }) },
  { path: '/search', redirect: (to: any) => ({ name: 'assistant', query: to.query }) },
  {
    path: '/projects',
    name: 'projects',
    component: () => import('../components/ProjectsPage.vue'),
    meta: { title: 'Tracium -Projects', requiresAuth: true }
  },
  {
    path: '/admin',
    name: 'admin',
    component: () => import('../components/AdminPage.vue'),
    meta: { title: 'Tracium - Administration', requiresAuth: true }
  },
  {
    path: '/invite/:token',
    name: 'invite',
    component: () => import('../components/InvitePage.vue'),
    meta: { title: 'Tracium - Accept Invitation', requiresAuth: false, isLoginPage: true }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach(async (to, _from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title as string
  }

  if (!to.meta.requiresAuth) {
    return next()
  }

  const token = localStorage.getItem('authToken')
  if (!token) {
    return next({ name: 'login', query: { redirect: to.fullPath } })
  }

  // Check if token is expired by decoding the JWT payload
  try {
    const payload = JSON.parse(atob(token.split('.')[1]))
    if (payload.exp && payload.exp * 1000 < Date.now()) {
      localStorage.removeItem('authToken')
      return next({ name: 'login', query: { redirect: to.fullPath } })
    }
  } catch {
    localStorage.removeItem('authToken')
    return next({ name: 'login', query: { redirect: to.fullPath } })
  }

  next()
})

export default router
